// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SitesAndPrescribersByTenantRequestModel {
    static getAttributeTypeMap() {
        return SitesAndPrescribersByTenantRequestModel.attributeTypeMap;
    }
}
SitesAndPrescribersByTenantRequestModel.discriminator = undefined;
SitesAndPrescribersByTenantRequestModel.additionalProperties = false;
SitesAndPrescribersByTenantRequestModel.attributeTypeMap = [
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dea",
        "baseName": "dea",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "medicaidId",
        "baseName": "medicaidId",
        "type": "string"
    },
    {
        "name": "stateTaxId",
        "baseName": "stateTaxId",
        "type": "string"
    },
    {
        "name": "stateLicenseId",
        "baseName": "stateLicenseId",
        "type": "string"
    },
    {
        "name": "prescriberTaxId",
        "baseName": "prescriberTaxId",
        "type": "string"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
    {
        "name": "isActive",
        "baseName": "isActive",
        "type": "boolean"
    },
];
//# sourceMappingURL=sitesAndPrescribersByTenantRequestModel.js.map